module.exports = require("plugin-assets/shared/widget/multi-channel/editor/preview-and-data");